import React from "react";
import styled from "styled-components";

const Button = styled.button`
  border-radius: 50%;
  border: 2px solid #ffffff;
  background: #4db6ac;

  :hover {
    background: #419e95;
  }
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const CircleIconButton = (props) => {
  return <Button {...props}>{props.children}</Button>;
};

export default CircleIconButton;
